import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, ShieldCheck, Clock } from 'lucide-react';
import ContactForm from '@/components/ContactForm';
import InkPhDLogo from '@/components/InkPhDLogo';
import AppFooter from '@/components/AppFooter';
import SeoHead from '@/components/SeoHead';

export default function ContactPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-[#0a0e1a] text-foreground thesis-brand">
      <SeoHead title="Contact InkPhD" path="/contact"
        description="Contact the InkPhD team — support, billing, institutional enquiries and data requests." />
      <header className="border-b border-border">
        <div className="max-w-5xl mx-auto px-3 sm:px-6 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
            data-testid="contact-back-link">
            <ArrowLeft className="w-4 h-4" /> Home
          </Link>
          <InkPhDLogo size="sm" />
        </div>
      </header>

      <main className="flex-1 w-full max-w-5xl mx-auto px-3 sm:px-6 py-12 sm:py-16"
        data-testid="contact-page">
        <div className="grid lg:grid-cols-[1.2fr_1fr] gap-10">
          <div>
            <h1 className="text-4xl sm:text-5xl font-serif font-semibold tracking-tight mb-4"
              style={{ fontFamily: '"Fraunces", Georgia, serif' }}>
              Talk to <span className="text-[#1d4ed8] dark:text-[#7aa9ff]">us</span>
            </h1>
            <p className="text-base text-muted-foreground mb-8">
              Support, billing, institutional licences, journal-author campaigns, GDPR and data
              requests — one form, and it reaches the team directly.
            </p>
            <ContactForm />
          </div>
          <aside className="space-y-4">
            {[
              [Clock, 'Reply time', 'Within two working days. Billing and access issues are prioritised.'],
              [ShieldCheck, 'Your data', 'Used only to answer this enquiry. No newsletter, no sharing, deleted on request.'],
              [Mail, 'Data requests', 'For GDPR export or erasure you can also do it yourself: Profile → Data & privacy.'],
            ].map(([Icon, title, body]) => (
              <div key={title} className="rounded-xl border border-border p-4">
                <p className="text-sm font-semibold flex items-center gap-2 mb-1">
                  <Icon className="w-4 h-4 text-[#1d4ed8]" /> {title}
                </p>
                <p className="text-[13px] text-muted-foreground leading-relaxed">{body}</p>
              </div>
            ))}
          </aside>
        </div>
      </main>

      <AppFooter lang="en" />
    </div>
  );
}
